import { combineReducers } from "redux";
import { plansReducer } from "./plansReducer";
import { snackBarReducer } from "./snackBarReducer";

const reducers = combineReducers({
  plans: plansReducer,
  snackBar: snackBarReducer
});
const rootReducer = (state: any, action: any) => {
  return reducers(state, action);
};

export default rootReducer;
